import { useQuery } from "@tanstack/react-query";
import { fetchVendorCategories } from "../../../services/vendorCategories";

export function useVendorCategories(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["gvm-vendor-categories"],
    queryFn: () => fetchVendorCategories(),
    staleTime: 10 * 60_000,
    refetchOnWindowFocus: false,
    enabled: options.enabled ?? true,
  });
}
